import { supabase } from "./supabaseClient";

export async function getSession() {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
}

export async function getUser() {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}

// Calls onChange(session) whenever the user signs in or out.
// Returns a function that stops listening.
export function onSessionChange(onChange) {
  const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
    onChange(session);
  });
  return () => subscription.unsubscribe();
}

export function signOut() {
  return supabase.auth.signOut();
}
